module.exports = "/images/variable-contract.svg?1520b613244b3ca486ffe9b2a60a1df7";